import { useMemo } from "react";
import { useCommonColumns } from "../../../../utils/hooks/useCommonColumns";

export const useColumns = ({ edit, remove, clone }) => {
	const {
		code,
		description,
		status,
		actions,
	} = useCommonColumns({ edit, remove, clone });

	return useMemo(() => {
		const columns = [code, description, status];
		if (actions) {
			columns.push(actions);
		}
		return columns;
	}, [code, description, status, actions]);
};
